import React from 'react'

function LandingFooter() {
    const scrollToPriceSection = (event) => {
        event.preventDefault(); // Prevent the default behavior of the anchor tag

        const priceSection = document.getElementById('price-section');

        if (priceSection) {
            priceSection.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <>
            {/* <div className='bg-[url("./images/background4.png")] flex justify-center items-center w-full lg:px-16 px-6 py-8 text-white'>
                <p className='text-sm md:text-base lg:text-lg text-center max-w-4xl'>Dominar o inglês não é apenas uma habilidade, mas um caminho para oportunidades ilimitadas. Faça a escolha certa para o seu crescimento pessoal e profissional!</p>
            </div> */}

        </>
    )
}

export default LandingFooter